import { useMentionPlugin, MentionSelect, renderMentionItem } from '@sketchnote/minimal-editor';
import { ELEMENT_MICRO_TASK, ELEMENT_CALLOUT_TIP, ELEMENT_MULTI_COL, toggleList as toggleList$1, useComments, useSlatePluginsStore, BalloonToolbar, MicroTaskElement, MultiColumnElement, ELEMENT_COL, ColumnElement, CalloutElement, ELEMENT_TABLE_PLUS, TablePlusElement, ImageElement, ELEMENT_BOARD, BoardElement, TodoListElement, LinkElement, ELEMENT_LEGAL_PH, LegalPhElement, MARK_COMMENT_ID, CommentLeaf, ELEMENT_EMBED, EmbedElement, HrElement, withDraggables, ELEMENT_AI_CONTENT, createEmbedPlugin, createCalloutTipPlugin, createTablePlusPlugin, createBoardPlugin, createAiContentPlugin, createLegalPhPlugin, createMultiColPlugin, createColPlugin, createCommentPlugin, ELEMENT_CODE_HIGHLIGHT_BLOCK, useSlashOnSelectItem, useComboboxOnKeyDown, createDeserializeHtmlPlugin, createCodeBlockPlugin as createCodeBlockPlugin$1, createMicroTaskPlugin, createIndentPlugin, createDeserializeMdPlugin, Comments, useOnSlashChange, useComboboxIsOpen, useComboBoxStore, useComboboxControls, SlashComboBox } from '@sketchnote/slate-plugins';
import { unwrapList, getParentNode, isElement, isType, ELEMENT_CODE_BLOCK, ELEMENT_CODE_LINE, toggleList, ELEMENT_H1, ELEMENT_H2, ELEMENT_H3, ELEMENT_H4, ELEMENT_H5, ELEMENT_H6, ELEMENT_BLOCKQUOTE, ELEMENT_HR, setNodes, insertNodes, ELEMENT_DEFAULT, ELEMENT_LI, ELEMENT_TODO_LI, ELEMENT_UL, ELEMENT_OL, MARK_BOLD, MARK_ITALIC, MARK_UNDERLINE, MARK_STRIKETHROUGH, MARK_SUPERSCRIPT, MARK_SUBSCRIPT, MARK_HIGHLIGHT, MARK_CODE, autoformatSmartQuotes, autoformatPunctuation, autoformatLegal, autoformatLegalHtml, autoformatArrow, autoformatMath, createPlateUI, withProps, CodeBlockElement, ELEMENT_PARAGRAPH, isBlockAboveEmpty, isSelectionAtBlockStart, ELEMENT_TD, KEYS_HEADING, ELEMENT_IMAGE, useEditorRef, useEditorState, someNode, getPreventDefaultHandler, toggleNodeType, ELEMENT_LINK, getAboveNode, unwrapNodes, isCollapsed, upsertLink, usePlateEditorState, getListItemEntry, isMarkActive, toggleMark, removeMark, setMarks, usePlateEditorRef, MARK_COLOR, MARK_BG_COLOR, ELEMENT_MENTION, MentionElement, StyledElement, BlockquoteElement, withStyledProps, StyledLeaf, withPlaceholders, ELEMENT_TABLE, ELEMENT_MEDIA_EMBED, createPlugins, createParagraphPlugin, createBlockquotePlugin, createTodoListPlugin, createReactPlugin, createHistoryPlugin, createHeadingPlugin, createListPlugin, createTablePlugin, createCodeBlockPlugin, createAlignPlugin, createBoldPlugin, createCodePlugin, createItalicPlugin, createHighlightPlugin, createUnderlinePlugin, createStrikethroughPlugin, createSubscriptPlugin, createSuperscriptPlugin, createKbdPlugin, createFontColorPlugin, createFontBackgroundColorPlugin, createNodeIdPlugin, createAutoformatPlugin, createResetNodePlugin, createSoftBreakPlugin, createExitBreakPlugin, createLinkPlugin, createSelectOnBackspacePlugin, escapeRegExp, getEditorString, usePlateId, createImagePlugin, createPluginFactory, createHorizontalRulePlugin, Plate } from '@udecode/plate';
import * as React from 'react';
import { v4 } from 'uuid';
import { css } from 'styled-components';
import { Editor, Transforms, Node, Path } from 'slate';
import { Popover, PopoverTrigger, Portal, PopoverContent } from '@chakra-ui/react';
import { AddIcon, DragIcon, UserIcon, DeleteIcon, ClipboardIcon, ChevronDownIcon, TextIcon, HeadingOneIcon, HeadingTwoIcon, HeadingThreeIcon, BlockQuoteIcon, CalloutIcon, TaskIcon, BulletedList, NumberedList, Bold, Italic, StrikethroughIcon, Underline, LinkIcon, CommmentTwoIcon, TodoLiIcon, TableIcon, BoardOne, CodeIcon, ImageIcon, EmbedIcon, AiMagicToolIcon } from '@sketchnote/icons';
import cn from 'classnames';
import { ReactEditor } from 'slate-react';
import { prependHttp, IconTextBtn } from '@sketchnote/shared-components';
import Tippy from '@tippyjs/react';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const clearBlockFormat = editor => unwrapList(editor);

const format = (editor, customFormatting) => {
  if (editor.selection) {
    const parentEntry = getParentNode(editor, editor.selection);
    if (!parentEntry) return;
    const [node] = parentEntry;

    if (isElement(node) && !isType(editor, node, ELEMENT_CODE_BLOCK) && !isType(editor, node, ELEMENT_CODE_LINE)) {
      customFormatting();
    }
  }
};

const formatList = (editor, elementType) => {
  format(editor, () => toggleList(editor, {
    type: elementType
  }));
};

const autoformatBlocks = [{
  mode: 'block',
  type: ELEMENT_H1,
  match: '# ',
  preFormat: clearBlockFormat
}, {
  mode: 'block',
  type: ELEMENT_H2,
  match: '## ',
  preFormat: clearBlockFormat
}, {
  mode: 'block',
  type: ELEMENT_H3,
  match: '### ',
  preFormat: clearBlockFormat
}, {
  mode: 'block',
  type: ELEMENT_H4,
  match: '#### ',
  preFormat: clearBlockFormat
}, {
  mode: 'block',
  type: ELEMENT_H5,
  match: '##### ',
  preFormat: clearBlockFormat
}, {
  mode: 'block',
  type: ELEMENT_H6,
  match: '###### ',
  preFormat: clearBlockFormat
}, {
  mode: 'block',
  type: ELEMENT_BLOCKQUOTE,
  match: '> ',
  preFormat: clearBlockFormat
}, {
  mode: 'block',
  type: ELEMENT_HR,
  match: ['---', '—-'],
  preFormat: clearBlockFormat,
  format: editor => {
    setNodes(editor, {
      type: ELEMENT_HR
    });
    insertNodes(editor, {
      type: ELEMENT_DEFAULT,
      children: [{
        text: ''
      }]
    });
  }
}, {
  mode: 'block',
  type: ELEMENT_CODE_BLOCK,
  match: '```',
  triggerAtBlockStart: false,
  preFormat: clearBlockFormat
}];
const autoformatLists = [{
  mode: 'block',
  type: ELEMENT_LI,
  match: ['* ', '- '],
  preFormat: clearBlockFormat,
  format: editor => formatList(editor, ELEMENT_UL)
}, {
  mode: 'block',
  type: ELEMENT_LI,
  match: ['1. ', '1) '],
  preFormat: clearBlockFormat,
  format: editor => formatList(editor, ELEMENT_OL)
}, {
  mode: 'block',
  type: ELEMENT_TODO_LI,
  match: '[] '
}, {
  mode: 'block',
  type: ELEMENT_TODO_LI,
  match: '[x] ',
  format: editor => setNodes(editor, {
    type: ELEMENT_TODO_LI,
    checked: true
  }, {
    match: n => Editor.isBlock(editor, n)
  })
}];
const autoformatMarks = [{
  mode: 'mark',
  type: [MARK_BOLD, MARK_ITALIC],
  match: '***'
}, {
  mode: 'mark',
  type: [MARK_UNDERLINE, MARK_ITALIC],
  match: '__*'
}, {
  mode: 'mark',
  type: [MARK_UNDERLINE, MARK_BOLD],
  match: '__**'
}, {
  mode: 'mark',
  type: [MARK_UNDERLINE, MARK_BOLD, MARK_ITALIC],
  match: '___***'
}, {
  mode: 'mark',
  type: MARK_BOLD,
  match: '**'
}, {
  mode: 'mark',
  type: MARK_UNDERLINE,
  match: '__'
}, {
  mode: 'mark',
  type: MARK_ITALIC,
  match: '*'
}, {
  mode: 'mark',
  type: MARK_ITALIC,
  match: '_'
}, {
  mode: 'mark',
  type: MARK_STRIKETHROUGH,
  match: '~~'
}, {
  mode: 'mark',
  type: MARK_SUPERSCRIPT,
  match: '^'
}, {
  mode: 'mark',
  type: MARK_SUBSCRIPT,
  match: '~'
}, {
  mode: 'mark',
  type: MARK_HIGHLIGHT,
  match: '=='
}, {
  mode: 'mark',
  type: MARK_HIGHLIGHT,
  match: '≡'
}, {
  mode: 'mark',
  type: MARK_CODE,
  match: '`'
}];
const autoformatRules = [...autoformatBlocks, ...autoformatLists, ...autoformatMarks, ...autoformatSmartQuotes, ...autoformatPunctuation, ...autoformatLegal, ...autoformatLegalHtml, ...autoformatArrow, ...autoformatMath];
const resetBlockTypesCommonRule = {
  types: [ELEMENT_BLOCKQUOTE, ELEMENT_TODO_LI, ELEMENT_H1, ELEMENT_H2, ELEMENT_H3, ELEMENT_H4, ELEMENT_H5, ELEMENT_H6, ELEMENT_MICRO_TASK, ELEMENT_CALLOUT_TIP, ELEMENT_MULTI_COL],
  defaultType: ELEMENT_PARAGRAPH
};
const CONFIG = {
  editableProps: {
    spellCheck: false,
    autoFocus: false,
    placeholder: 'Type…',
    style: {
      padding: '15px'
    }
  },
  components: createPlateUI({
    [ELEMENT_CODE_BLOCK]: withProps(CodeBlockElement, {
      styles: {
        root: [css`
            background-color: #111827;
            code {
              color: white;
            }
          `]
      }
    })
  }),
  align: {
    inject: {
      props: {
        validTypes: [ELEMENT_PARAGRAPH, ELEMENT_H1, ELEMENT_H2, ELEMENT_H3, ELEMENT_H4, ELEMENT_H5, ELEMENT_H6]
      }
    }
  },
  indent: {
    inject: {
      props: {
        validTypes: [ELEMENT_PARAGRAPH, ELEMENT_H1, ELEMENT_H2, ELEMENT_H3, ELEMENT_H4, ELEMENT_H5, ELEMENT_H6, ELEMENT_BLOCKQUOTE, ELEMENT_CODE_BLOCK]
      }
    }
  },
  lineHeight: {
    inject: {
      props: {
        defaultNodeValue: 1.5,
        validNodeValues: [1, 1.2, 1.5, 2, 3],
        validTypes: [ELEMENT_PARAGRAPH, ELEMENT_H1, ELEMENT_H2, ELEMENT_H3, ELEMENT_H4, ELEMENT_H5, ELEMENT_H6]
      }
    }
  },
  resetBlockType: {
    options: {
      rules: [Object.assign(Object.assign({}, resetBlockTypesCommonRule), {
        hotkey: 'Enter',
        predicate: isBlockAboveEmpty
      }), Object.assign(Object.assign({}, resetBlockTypesCommonRule), {
        hotkey: 'Backspace',
        predicate: isSelectionAtBlockStart
      })]
    }
  },
  trailingBlock: {
    type: ELEMENT_PARAGRAPH
  },
  softBreak: {
    options: {
      rules: [{
        hotkey: 'shift+enter'
      }, {
        hotkey: 'enter',
        query: {
          allow: [ELEMENT_CODE_BLOCK, ELEMENT_BLOCKQUOTE, ELEMENT_TD]
        }
      }]
    }
  },
  exitBreak: {
    options: {
      rules: [{
        hotkey: 'mod+enter'
      }, {
        hotkey: 'mod+shift+enter',
        before: true
      }, {
        hotkey: 'enter',
        query: {
          start: true,
          end: true,
          allow: [...KEYS_HEADING, ELEMENT_MICRO_TASK, ELEMENT_CALLOUT_TIP, ELEMENT_BLOCKQUOTE, ELEMENT_DEFAULT]
        }
      }]
    }
  },
  selectOnBackspace: {
    options: {
      query: {
        allow: [ELEMENT_IMAGE, ELEMENT_HR]
      }
    }
  },
  autoformat: {
    options: {
      rules: autoformatRules
    }
  },
  forceLayout: {
    options: {
      rules: [{
        path: [0],
        strictType: ELEMENT_H1
      }]
    }
  }
};
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

const {
  useCallback: useCallback$2,
  useMemo: useMemo$1,
  Fragment: Fragment$1,
  forwardRef
} = React; // eslint-disable-next-line react/display-name

const BlockToolbar = /*#__PURE__*/React.memo(({
  element,
  isMenuOpened,
  setIsMenuOpened
}) => {
  const editor = useEditorRef();
  const handleDeleteNode = useCallback$2(() => {
    const path = ReactEditor.findPath(editor, element);
    Transforms.removeNodes(editor, {
      at: path
    });
  }, [element, editor]);
  const handleAddNewNode = useCallback$2(() => {
    try {
      ReactEditor.focus(editor);
      const str = Node.string(element);
      const path = ReactEditor.findPath(editor, element);
      let at;

      if (str.length === 0 && element.type === ELEMENT_DEFAULT) {
        at = path;
      } else {
        at = Path.next(path);
      }

      insertNodes(editor, {
        type: ELEMENT_DEFAULT,
        children: [{
          text: ''
        }]
      }, {
        at
      }); // Insert `/` in next line to open the weapons menu

      Transforms.insertText(editor, '/', {
        at
      }); // there is no option to place the cursor using path with move() method
      // so ended up using select() method
      // this will actually place the cursor before `/` see below why

      Transforms.select(editor, {
        path: at,
        offset: 0
      }); // can't directly place the cursor in offset 1 since it's producing `cannot resolve node` bug
      // when I using move method it's working fine
      // finally moved the cursor to the right place next to the `/`

      Transforms.move(editor, {
        distance: 1,
        unit: 'offset'
      });
    } catch (error) {
      console.log(error);
    }
  }, [element, editor]);
  const handleDuplicateNode = useCallback$2(() => {
    const path = ReactEditor.findPath(editor, element);
    const at = Path.next(path);
    const newElement = Object.assign({}, element);

    if (newElement.id) {
      delete newElement.id;
    }

    Transforms.insertNodes(editor, newElement, {
      at
    });
  }, [editor, element]);

  const handleMenuOpen = () => {
    setIsMenuOpened(true);
  };

  const handleMenuClose = () => {
    setIsMenuOpened(false);
  };

  const handleToggleAssignPeople = useCallback$2(() => {
    const path = ReactEditor.findPath(editor, element);
    Transforms.setNodes(editor, {
      isAssign: !element.isAssign,
      assignedDates: [],
      members: []
    }, {
      at: path
    });
    handleMenuClose();
  }, [element, editor]);
  const popover = useMemo$1(() => {
    return /*#__PURE__*/React.createElement(Popover, {
      closeOnBlur: true,
      onClose: handleMenuClose,
      onOpen: handleMenuOpen,
      isOpen: isMenuOpened,
      placement: "left-start",
      modifiers: [{
        name: 'eventListeners',
        options: {
          scroll: isMenuOpened
        }
      }]
    }, ({
      isOpen
    }) => {
      var _a;

      return /*#__PURE__*/React.createElement(Fragment$1, null, /*#__PURE__*/React.createElement("button", {
        id: "clickAdd",
        onClick: handleAddNewNode,
        className: "text-gray-500"
      }, /*#__PURE__*/React.createElement(AddIcon, null)), /*#__PURE__*/React.createElement(PopoverTrigger, null, /*#__PURE__*/React.createElement("button", {
        className: "w-full text-left flex justify-between items-center text-gray-500"
      }, /*#__PURE__*/React.createElement("span", {
        className: cn({
          'px-8 py-1 rounded': true
        })
      }, /*#__PURE__*/React.createElement(DragIcon, {
        size: 8
      })))), /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(PopoverContent, {
        className: "p-6 bg-white shadow-lg rounded-md max-h-304 min-w-160 overflow-auto "
      }, isOpen ? /*#__PURE__*/React.createElement(Fragment$1, null, element.type === 'micro_task' ? /*#__PURE__*/React.createElement(Fragment$1, null, /*#__PURE__*/React.createElement(Item, {
        leftIcon: UserIcon,
        onClick: handleToggleAssignPeople,
        label: element.isAssign ? 'Remove Assign' : 'Assign'
      }), /*#__PURE__*/React.createElement("div", {
        className: "border-b border-gray-200 my-5"
      })) : null, (editor.children.length > 1 || ((_a = editor.children) === null || _a === void 0 ? void 0 : _a[0].type) === ELEMENT_MULTI_COL) && /*#__PURE__*/React.createElement(Item, {
        leftIcon: DeleteIcon,
        onClick: handleDeleteNode,
        label: "Delete"
      }), /*#__PURE__*/React.createElement(Item, {
        leftIcon: ClipboardIcon,
        onClick: handleDuplicateNode,
        label: "Duplicate"
      })) : null)));
    });
  }, [handleAddNewNode, handleDeleteNode, handleDuplicateNode, isMenuOpened]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, popover);
});
const Item = forwardRef( // eslint-disable-next-line react/prop-types
(_a, ref) => {
  var {
    isRightArrow,
    label,
    leftIcon: LeftIcon
  } = _a,
      otherProps = __rest(_a, ["isRightArrow", "label", "leftIcon"]);

  return /*#__PURE__*/React.createElement("button", Object.assign({
    ref: ref,
    className: "px-8 w-full text-left py-7 rounded-sm min-w-btn-lg hover:bg-gray-100 cursor-pointer align-middle justify-between flex items-center font-regular"
  }, otherProps), /*#__PURE__*/React.createElement("span", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement(LeftIcon, {
    className: "mr-8 text-lg text-gray-500"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-sm"
  }, label)), isRightArrow ? /*#__PURE__*/React.createElement("span", {
    style: {
      transform: 'rotate(-90deg)',
      transition: 'all 0.5s'
    }
  }, /*#__PURE__*/React.createElement(ChevronDownIcon, {
    className: "text-gray-200"
  })) : null);
});
Item.displayName = 'Item';

const ToolbarButton = ({
  icon,
  tooltip,
  onMouseDown,
  label,
  active = false,
  btnRef
}) => {
  const tooltipProps = Object.assign({
    content: '',
    arrow: false,
    offset: [0, 17],
    delay: 0,
    duration: [200, 0],
    hideOnClick: false,
    trigger: 'hover'
  }, tooltip);

  function handleKeyDown(e) {
    if (e.key === 'Enter') {
      onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e);
    }
  }

  const button = /*#__PURE__*/React.createElement("button", {
    onMouseDown: onMouseDown,
    onKeyDown: handleKeyDown,
    ref: btnRef,
    className: cn({
      'px-10 py-5 hover:bg-gray-100 rounded-sm flex items-center focus:shadow-outline': true,
      'text-primary-500': active
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: "flex"
  }, " ", icon), label ? /*#__PURE__*/React.createElement("span", {
    className: "ml-8"
  }, label) : null);
  return tooltip ? /*#__PURE__*/React.createElement(Tippy, Object.assign({}, tooltipProps), button) : button;
};

const ToolbarElement = _a => {
  var {
    type,
    inactiveType,
    icon,
    label,
    tooltip,
    btnRef
  } = _a,
      otherProps = __rest(_a, ["type", "inactiveType", "icon", "label", "tooltip", "btnRef"]);

  const editor = useEditorState();
  return /*#__PURE__*/React.createElement(ToolbarButton, Object.assign({
    active: someNode(editor, {
      match: {
        type
      }
    }),
    icon: icon,
    label: label,
    tooltip: tooltip,
    btnRef: btnRef,
    onMouseDown: getPreventDefaultHandler(toggleNodeType, editor, {
      activeType: type,
      inactiveType
    })
  }, otherProps));
};

const {
  useCallback: useCallback$1
} = React;

const ToolbarLink = props => {
  const editor = useEditorState();
  const isLink = someNode(editor, {
    match: {
      type: ELEMENT_LINK
    }
  });
  const handleMouseDown = useCallback$1(event => {
    event.preventDefault();
    let prevUrl = '';
    const linkNode = getAboveNode(editor, {
      match: {
        type: ELEMENT_LINK
      }
    });

    if (linkNode) {
      prevUrl = linkNode[0].url;
    }

    let url = window.prompt(`Enter the URL of the link:`, prevUrl);

    if (!url) {
      linkNode && editor.selection && unwrapNodes(editor, {
        at: editor.selection,
        match: {
          type: ELEMENT_LINK
        }
      });
      return;
    }

    url = prependHttp(url, {
      https: false
    }); // If our cursor is in middle of a link, then we don't want to inser it inline

    const shouldWrap = linkNode !== undefined && isCollapsed(editor.selection); // insertTextInLink needs to be tested

    upsertLink(editor, {
      url,
      insertTextInLink: shouldWrap
    });
  }, []);
  return /*#__PURE__*/React.createElement(ToolbarButton, Object.assign({
    active: isLink,
    onMouseDown: handleMouseDown
  }, props));
};

const ToolbarList = _a => {
  var {
    type = ELEMENT_UL,
    icon,
    label,
    tooltip,
    btnRef
  } = _a,
      props = __rest(_a, ["type", "icon", "label", "tooltip", "btnRef"]);

  const editor = usePlateEditorState();
  const res = !!(editor === null || editor === void 0 ? void 0 : editor.selection) && getListItemEntry(editor);
  return /*#__PURE__*/React.createElement(ToolbarButton, Object.assign({
    active: !!res && res.list[0].type === type,
    icon: icon,
    label: label,
    tooltip: tooltip,
    btnRef: btnRef,
    onMouseDown: editor && getPreventDefaultHandler(toggleList$1, editor, {
      type
    })
  }, props));
};

const ToolbarMark = ({
  type,
  icon,
  label,
  tooltip
}) => {
  const editor = useEditorState();
  return /*#__PURE__*/React.createElement(ToolbarButton, {
    active: isMarkActive(editor, type),
    icon: icon,
    onMouseDown: getPreventDefaultHandler(toggleMark, editor, {
      key: type
    }),
    label: label,
    tooltip: tooltip
  });
};

const ToolbarMarkTextColor = ({
  type,
  icon,
  label,
  tooltip,
  color,
  onClick
}) => {
  const editor = useEditorState();

  const handleMouseDown = e => {
    e.preventDefault();

    if (color === 'Default') {
      removeMark(editor, {
        key: type
      });
    } else {
      setMarks(editor, {
        [type]: color
      });
    }

    onClick === null || onClick === void 0 ? void 0 : onClick();
  };

  return /*#__PURE__*/React.createElement(ToolbarButton, {
    active: false,
    icon: icon,
    onMouseDown: handleMouseDown,
    label: label,
    tooltip: tooltip
  });
};

const {
  useState
} = React;

const SelectionToolbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isColorOpen, setIsColorOpen] = useState(false);
  const [isHighlightOpen, setIsHighlightOpen] = useState(false);
  const editor = usePlateEditorRef();
  const setActiveComment = useComments(s => s.setActiveComment);
  const setHideSelectionTool = useSlatePluginsStore(s => s.setHideSelectionTool);

  const toggleMenu = value => () => {
    setIsOpen(value !== null && value !== void 0 ? value : !isOpen);
  };

  const toggleColorMenu = value => () => {
    setIsColorOpen(value !== null && value !== void 0 ? value : !isOpen);
  };

  const toggleHighlightMenu = value => () => {
    setIsHighlightOpen(value !== null && value !== void 0 ? value : !isOpen);
  };

  const handleOnNewCommentThread = e => {
    e.preventDefault();
    e.stopPropagation();
    const domSelection = window.getSelection();
    if (!domSelection || domSelection.rangeCount < 1) return;
    const domRange = domSelection.getRangeAt(0);

    if (editor === null || editor === void 0 ? void 0 : editor.selection) {
      setActiveComment({
        range: domRange,
        selection: editor === null || editor === void 0 ? void 0 : editor.selection
      });
    }

    setHideSelectionTool(true);
    editor && ReactEditor.deselect(editor);
  };

  return /*#__PURE__*/React.createElement(BalloonToolbar, null, /*#__PURE__*/React.createElement("div", {
    className: "bg-white px-12 flex py-4 mb-16",
    style: {
      color: '#55585E',
      border: 'none',
      boxShadow: '0px 2px 8px rgba(19, 23, 32, 0.16)'
    }
  }, /*#__PURE__*/React.createElement(Popover, {
    placement: "bottom",
    isOpen: isOpen,
    onOpen: toggleMenu(true),
    onClose: toggleMenu(false),
    modifiers: [{
      name: 'eventListeners',
      options: {
        scroll: isOpen
      }
    }]
  }, /*#__PURE__*/React.createElement(PopoverTrigger, null, /*#__PURE__*/React.createElement(IconTextBtn, {
    className: "p-5",
    color: "gray",
    iconRight: /*#__PURE__*/React.createElement(ChevronDownIcon, {
      wrapperClass: "ml-12"
    })
  }, "Text")), /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(PopoverContent, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col p-12 rounded-lg bg-white shadow-md text-gray-600"
  }, /*#__PURE__*/React.createElement(ToolbarElement, {
    type: ELEMENT_DEFAULT,
    tooltip: {
      content: 'Heading 1 Ctrl+1',
      placement: 'right',
      arrow: false
    },
    icon: /*#__PURE__*/React.createElement(TextIcon, null),
    label: "Text"
  }), /*#__PURE__*/React.createElement(ToolbarElement, {
    type: ELEMENT_H1,
    tooltip: {
      content: 'Heading 1 Ctrl+1',
      placement: 'right',
      arrow: false
    },
    icon: /*#__PURE__*/React.createElement(HeadingOneIcon, null),
    label: "Heading 1"
  }), /*#__PURE__*/React.createElement(ToolbarElement, {
    type: ELEMENT_H2,
    tooltip: {
      content: 'Heading 2 Ctrl+2',
      placement: 'right',
      arrow: false
    },
    icon: /*#__PURE__*/React.createElement(HeadingTwoIcon, null),
    label: "Heading 2"
  }), /*#__PURE__*/React.createElement(ToolbarElement, {
    type: ELEMENT_H3,
    tooltip: {
      content: 'Heading 3 Ctrl+3',
      placement: 'right',
      arrow: false
    },
    icon: /*#__PURE__*/React.createElement(HeadingThreeIcon, null),
    label: "Heading 3"
  }), /*#__PURE__*/React.createElement(ToolbarElement, {
    type: ELEMENT_BLOCKQUOTE,
    icon: /*#__PURE__*/React.createElement(IconTextBtn, {
      iconLeft: /*#__PURE__*/React.createElement(BlockQuoteIcon, null)
    }),
    tooltip: {
      content: 'Quote Ctrl+6',
      placement: 'right',
      arrow: false
    },
    label: "Quote"
  }), /*#__PURE__*/React.createElement(ToolbarElement, {
    type: ELEMENT_CALLOUT_TIP,
    icon: /*#__PURE__*/React.createElement(IconTextBtn, {
      iconLeft: /*#__PURE__*/React.createElement(CalloutIcon, null)
    }),
    tooltip: {
      content: 'Add Callout Ctrl+8',
      placement: 'right',
      arrow: false
    },
    label: "Callout tip"
  }), /*#__PURE__*/React.createElement(ToolbarElement, {
    type: ELEMENT_MICRO_TASK,
    icon: /*#__PURE__*/React.createElement(IconTextBtn, {
      iconLeft: /*#__PURE__*/React.createElement(CalloutIcon, null)
    }),
    tooltip: {
      content: 'Add Microtask Ctrl+8',
      placement: 'right',
      arrow: false
    },
    label: "Task"
  }), /*#__PURE__*/React.createElement(ToolbarElement, {
    type: ELEMENT_TODO_LI,
    icon: /*#__PURE__*/React.createElement(IconTextBtn, {
      iconLeft: /*#__PURE__*/React.createElement(TaskIcon, null)
    }),
    tooltip: {
      content: 'Add Microtask Ctrl+8',
      placement: 'right',
      arrow: false
    },
    label: "Todo List"
  }), /*#__PURE__*/React.createElement(ToolbarList, {
    type: ELEMENT_UL,
    icon: /*#__PURE__*/React.createElement(IconTextBtn, {
      iconLeft: /*#__PURE__*/React.createElement(BulletedList, null)
    }),
    tooltip: {
      content: 'Add Microtask Ctrl+8',
      placement: 'right',
      arrow: false
    },
    label: "Bullet list"
  }), /*#__PURE__*/React.createElement(ToolbarList, {
    type: ELEMENT_OL,
    icon: /*#__PURE__*/React.createElement(IconTextBtn, {
      iconLeft: /*#__PURE__*/React.createElement(NumberedList, null)
    }),
    tooltip: {
      content: 'Add Microtask Ctrl+8',
      placement: 'right',
      arrow: false
    },
    label: "Ordered list"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: " border-r mx-10"
  }), /*#__PURE__*/React.createElement(ToolbarMark, {
    type: MARK_BOLD,
    icon: /*#__PURE__*/React.createElement(Bold, null),
    tooltip: {
      content: 'Bold Ctrl+B',
      placement: 'bottom',
      arrow: false
    }
  }), /*#__PURE__*/React.createElement(ToolbarMark, {
    type: MARK_ITALIC,
    icon: /*#__PURE__*/React.createElement(Italic, null),
    tooltip: {
      content: 'Italic Ctrl+I',
      placement: 'bottom',
      arrow: false
    }
  }), /*#__PURE__*/React.createElement(ToolbarMark, {
    type: MARK_STRIKETHROUGH,
    icon: /*#__PURE__*/React.createElement(StrikethroughIcon, {
      width: 15,
      height: 18
    }),
    tooltip: {
      content: 'Strikethrough Ctrl+S',
      placement: 'bottom',
      arrow: false
    }
  }), /*#__PURE__*/React.createElement(ToolbarMark, {
    type: MARK_UNDERLINE,
    icon: /*#__PURE__*/React.createElement(Underline, null),
    tooltip: {
      content: 'Underline Ctrl+U',
      placement: 'bottom',
      arrow: false
    }
  }), /*#__PURE__*/React.createElement(ToolbarLink, {
    icon: /*#__PURE__*/React.createElement(LinkIcon, null),
    tooltip: {
      content: 'Link Ctrl+L',
      placement: 'bottom',
      arrow: false
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: " border-r mx-10"
  }), /*#__PURE__*/React.createElement(Popover, {
    placement: "bottom",
    isOpen: isColorOpen,
    onOpen: toggleColorMenu(true),
    onClose: toggleColorMenu(false)
  }, /*#__PURE__*/React.createElement(PopoverTrigger, null, /*#__PURE__*/React.createElement(IconTextBtn, {
    className: "p-5",
    color: "gray",
    iconRight: /*#__PURE__*/React.createElement(ChevronDownIcon, {
      wrapperClass: "ml-12"
    })
  }, "Color")), /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(PopoverContent, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col p-12 rounded-lg bg-white shadow-md"
  }, colors.map((color, index) => /*#__PURE__*/React.createElement(ToolbarMarkTextColor, {
    key: `${color.label}-${index}`,
    color: color.color,
    type: MARK_COLOR,
    onClick: toggleColorMenu(false),
    tooltip: {
      content: 'Heading 1 Ctrl+1',
      placement: 'right',
      arrow: false
    },
    icon: /*#__PURE__*/React.createElement("span", {
      className: "w-14 h-14 rounded-full",
      style: {
        backgroundColor: color.bgColor
      }
    }),
    label: color.label
  })))))), /*#__PURE__*/React.createElement("div", {
    className: " border-r mx-10"
  }), /*#__PURE__*/React.createElement(Popover, {
    placement: "bottom",
    isOpen: isHighlightOpen,
    onOpen: toggleHighlightMenu(true),
    onClose: toggleHighlightMenu(false)
  }, /*#__PURE__*/React.createElement(PopoverTrigger, null, /*#__PURE__*/React.createElement(IconTextBtn, {
    className: "p-5",
    color: "gray",
    iconRight: /*#__PURE__*/React.createElement(ChevronDownIcon, {
      wrapperClass: "ml-12"
    })
  }, "Highlight")), /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(PopoverContent, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col p-12 rounded-lg bg-white shadow-md"
  }, bgColors.map((color, index) => /*#__PURE__*/React.createElement(ToolbarMarkTextColor, {
    key: `${color.label}-${index}`,
    color: color.color,
    type: MARK_BG_COLOR,
    tooltip: {
      content: 'Heading 1 Ctrl+1',
      placement: 'right',
      arrow: false
    },
    onClick: toggleHighlightMenu(false),
    icon: /*#__PURE__*/React.createElement("span", {
      className: "w-14 h-14 rounded-full border",
      style: {
        backgroundColor: color.bgColor,
        borderColor: color.borderColor
      }
    }),
    label: color.label
  })))))), /*#__PURE__*/React.createElement("div", {
    className: " border-r mx-10"
  }), /*#__PURE__*/React.createElement(IconTextBtn, {
    className: "p-5",
    color: "gray",
    onClick: handleOnNewCommentThread,
    iconLeft: /*#__PURE__*/React.createElement(CommmentTwoIcon, {
      className: "mr-12"
    })
  }, "Comment")));
};

const colors = [{
  label: 'Default',
  color: 'Default',
  bgColor: '#131720'
}, {
  label: 'Green',
  color: '#2BC545',
  bgColor: '#2BC545'
}, {
  label: 'Yellow',
  color: '#FFD321',
  bgColor: '#FFD321'
}, {
  label: 'Orange',
  color: '#FF9700',
  bgColor: '#FF9700'
}, {
  label: 'Red',
  color: '#F55540',
  bgColor: '#F55540'
}, {
  label: 'Pink',
  color: '#FF3F72',
  bgColor: '#FF3F72'
}, {
  label: 'Purple',
  color: '#9641D0',
  bgColor: '#9641D0'
}, {
  label: 'Blue',
  color: '#627FE5',
  bgColor: '#627FE5'
}];
const bgColors = [{
  label: 'Default',
  color: 'Default',
  bgColor: '#F6F7F9',
  borderColor: '#878A92'
}, {
  label: 'Green',
  color: '#DFF8E3',
  bgColor: '#DFF8E3',
  borderColor: '#2BC545'
}, {
  label: 'Yellow',
  color: '#FFF7D6',
  bgColor: '#FFF7D6',
  borderColor: '#FFD321'
}, {
  label: 'Orange',
  color: '#FFE6BF',
  bgColor: '#FFE6BF',
  borderColor: '#FF9700'
}, {
  label: 'Red',
  color: '#FEEFED',
  bgColor: '#FEEFED',
  borderColor: '#F4381F'
}, {
  label: 'Pink',
  color: '#FEDEE6',
  bgColor: '#FEDEE6',
  borderColor: '#FF7197'
}, {
  label: 'Purple',
  color: '#F1E2FF',
  bgColor: '#F1E2FF',
  borderColor: '#9641D0'
}, {
  label: 'Blue',
  color: '#EEF1FC',
  bgColor: '#EEF1FC',
  borderColor: '#254DDA'
}];
const ELEMENT_KANBAN = 'kanban';

const withStyledPlaceHolders = components => withPlaceholders(components, [{
  key: ELEMENT_PARAGRAPH,
  placeholder: "Type '/' to open weapons",
  hideOnBlur: true
}, {
  key: ELEMENT_H1,
  placeholder: 'Heading 1',
  hideOnBlur: false
}, {
  key: ELEMENT_H2,
  placeholder: 'Heading 2',
  hideOnBlur: false
}, {
  key: ELEMENT_H3,
  placeholder: 'Heading 3',
  hideOnBlur: false
}, {
  key: ELEMENT_BLOCKQUOTE,
  placeholder: 'Empty quote',
  hideOnBlur: false
}]);

const renderLabel = mentionable => {
  return `@${mentionable.name}`;
};

let components = createPlateUI({
  [ELEMENT_MENTION]: withProps(MentionElement, {
    renderLabel: renderLabel,
    styles: {
      root: {
        boxShadow: 'none',
        backgroundColor: 'inherit',
        color: '#254DDA',
        padding: '0px'
      }
    }
  }),
  [ELEMENT_MICRO_TASK]: MicroTaskElement,
  [ELEMENT_MULTI_COL]: MultiColumnElement,
  [ELEMENT_COL]: ColumnElement,
  [ELEMENT_CALLOUT_TIP]: CalloutElement,
  [ELEMENT_TABLE_PLUS]: TablePlusElement,
  [ELEMENT_IMAGE]: ImageElement,
  [ELEMENT_BOARD]: BoardElement,
  [ELEMENT_H1]: withProps(StyledElement, {
    as: 'h1',
    styles: {
      root: {
        margin: '3.2rem 0 0.4rem',
        fontSize: '3rem',
        fontWeight: 700,
        minHeight: '5.6rem'
      }
    }
  }),
  [ELEMENT_H2]: withProps(StyledElement, {
    as: 'h2',
    styles: {
      root: {
        fontWeight: 600,
        margin: '2.2rem 0 1px',
        fontSize: '2.4rem',
        minHeight: '6rem'
      }
    }
  }),
  [ELEMENT_H3]: withProps(StyledElement, {
    as: 'h3',
    styles: {
      root: {
        fontWeight: 600,
        margin: '1.8rem 0 1px',
        fontSize: '1.8rem',
        minHeight: '6rem'
      }
    }
  }),
  [ELEMENT_BLOCKQUOTE]: withProps(BlockquoteElement, {
    styles: {
      root: {
        borderLeft: '2px solid #878A92',
        color: '#131720',
        padding: '0px 2.6rem'
      }
    }
  }),
  [ELEMENT_TODO_LI]: withProps(TodoListElement, {
    styles: {
      checkbox: {
        width: '2rem',
        height: '2rem'
      },
      checkboxWrapper: {
        marginRight: '0.8rem'
      }
    }
  }),
  [ELEMENT_LINK]: LinkElement,
  [ELEMENT_KANBAN]: withProps(StyledElement, {
    as: 'h2',
    styles: {
      root: {
        fontWeight: 600,
        margin: '2.2rem 0 1px',
        fontSize: '2.4rem',
        minHeight: '6rem'
      }
    }
  }),
  [ELEMENT_LEGAL_PH]: LegalPhElement,
  [MARK_COLOR]: withStyledProps(StyledLeaf, {
    leafProps: {
      [MARK_COLOR]: ['color']
    }
  }),
  [MARK_BG_COLOR]: withStyledProps(StyledLeaf, {
    leafProps: {
      [MARK_BG_COLOR]: ['backgroundColor']
    }
  }),
  [MARK_COMMENT_ID]: CommentLeaf,
  [ELEMENT_EMBED]: EmbedElement,
  // Supporting the older coloring format
  'text-color': ({
    children,
    element
  }) => /*#__PURE__*/React.createElement("span", {
    style: {
      color: element.color
    }
  }, children),
  [ELEMENT_HR]: HrElement
});
components = withStyledPlaceHolders(components);
components = withDraggables(components, [{
  keys: [ELEMENT_UL, ELEMENT_OL],
  level: 0
}, {
  keys: [ELEMENT_PARAGRAPH, ELEMENT_BLOCKQUOTE, ELEMENT_TODO_LI, ELEMENT_H1, ELEMENT_H2, ELEMENT_H3, ELEMENT_H4, ELEMENT_H5, ELEMENT_H6, ELEMENT_IMAGE, ELEMENT_OL, ELEMENT_UL, ELEMENT_TABLE, ELEMENT_MEDIA_EMBED, ELEMENT_CODE_BLOCK, ELEMENT_MICRO_TASK, ELEMENT_MULTI_COL, ELEMENT_CALLOUT_TIP, ELEMENT_TABLE_PLUS, ELEMENT_KANBAN, ELEMENT_AI_CONTENT, ELEMENT_BOARD, ELEMENT_EMBED, ELEMENT_HR],
  onRenderDragHandle: BlockToolbar
}, {
  key: ELEMENT_H1,
  styles: {
    gutterLeft: {
      paddingTop: '1.5rem'
    }
  }
}, {
  key: ELEMENT_H2,
  styles: {
    gutterLeft: {
      paddingTop: '1rem'
    },
    blockToolbarWrapper: {
      height: '1.3em'
    }
  }
}, {
  key: ELEMENT_H3,
  styles: {
    blockToolbarWrapper: {
      height: '1.3em'
    },
    gutterLeft: {
      paddingTop: '0.4rem'
    }
  }
}, {
  key: ELEMENT_MICRO_TASK,
  styles: {
    gutterLeft: {
      paddingTop: '1.8rem'
    },
    blockToolbarWrapper: {
      height: '1.3em'
    }
  }
}, {
  key: ELEMENT_MULTI_COL,
  styles: {
    gutterLeft: {
      paddingTop: '1rem'
    },
    blockToolbarWrapper: {
      height: '1.3em'
    }
  }
}, {
  key: ELEMENT_TODO_LI,
  styles: {
    gutterLeft: {
      paddingTop: '1rem'
    }
  }
}, {
  key: ELEMENT_TABLE_PLUS,
  styles: {
    blockToolbarWrapper: {
      height: '1.3em'
    }
  }
}, {
  key: ELEMENT_HR,
  styles: {
    blockToolbarWrapper: {
      height: '1.3em'
    }
  }
}, {
  keys: [ELEMENT_H4, ELEMENT_H5, ELEMENT_H6],
  styles: {
    blockToolbarWrapper: {
      height: '1.3em'
    }
  }
}, {
  keys: [ELEMENT_PARAGRAPH, ELEMENT_UL, ELEMENT_OL],
  styles: {
    gutterLeft: {
      padding: '4px 0 0'
    }
  }
}]);
createPlugins([createParagraphPlugin(), createBlockquotePlugin(), createTodoListPlugin(), createReactPlugin(), createHistoryPlugin(), createParagraphPlugin(), createBlockquotePlugin(), createTodoListPlugin(), createHeadingPlugin(), createListPlugin(), createTablePlugin(), createEmbedPlugin(), createCodeBlockPlugin(), createAlignPlugin(), createBoldPlugin(), createCodePlugin(), createItalicPlugin(), createHighlightPlugin(), createUnderlinePlugin(), createStrikethroughPlugin(), createSubscriptPlugin(), createSuperscriptPlugin(), createKbdPlugin(), createFontColorPlugin(), createFontBackgroundColorPlugin(), createNodeIdPlugin({
  options: {
    idCreator: () => v4()
  }
}), createAutoformatPlugin(CONFIG.autoformat), createResetNodePlugin(CONFIG.resetBlockType), createSoftBreakPlugin(CONFIG.softBreak), createExitBreakPlugin(CONFIG.exitBreak), // Trailing Block causing issue with websocket for live collaboration
// createTrailingBlockPlugin({ type: ELEMENT_PARAGRAPH }),
createCalloutTipPlugin(), createTablePlusPlugin(), createBoardPlugin(), createLinkPlugin(), createAiContentPlugin(), createLegalPhPlugin(), createMultiColPlugin(), createColPlugin(), createSelectOnBackspacePlugin({
  options: {
    query: {
      allow: [ELEMENT_IMAGE]
    }
  }
}), createCommentPlugin()], {
  components
});
const _weapons = [{
  value: 'text',
  type: ELEMENT_DEFAULT,
  name: 'Text',
  icon: TextIcon,
  subText: 'Simply start typing'
}, {
  value: 'heading-1',
  name: 'Heading 1',
  icon: HeadingOneIcon,
  type: ELEMENT_H1,
  subText: 'For big headings'
}, {
  value: 'heading-2',
  name: 'Heading 2',
  icon: HeadingTwoIcon,
  type: ELEMENT_H2,
  subText: 'For medium headings'
}, {
  value: 'heading-3',
  name: 'Heading 3',
  icon: HeadingThreeIcon,
  type: ELEMENT_H3,
  subText: 'For small headings'
}, {
  value: 'callout',
  name: 'Callout',
  icon: CalloutIcon,
  type: ELEMENT_CALLOUT_TIP,
  subText: 'Highlight a line'
}, {
  value: 'micro-task',
  name: 'Task',
  icon: TaskIcon,
  type: ELEMENT_MICRO_TASK,
  subText: 'Create and assign tasks'
}, {
  value: 'todo-list',
  name: 'Todo List',
  icon: TodoLiIcon,
  type: ELEMENT_TODO_LI,
  subText: 'Start noting down tasks'
}, {
  value: 'table-plus',
  name: 'Table',
  icon: TableIcon,
  type: ELEMENT_TABLE_PLUS,
  subText: 'Add a table to the page'
}, {
  value: 'board',
  name: 'Board',
  icon: BoardOne,
  type: ELEMENT_BOARD,
  subText: 'Add a Kanban board to your page'
}, {
  value: 'codeblock',
  name: 'Code block',
  icon: CodeIcon,
  type: ELEMENT_CODE_HIGHLIGHT_BLOCK,
  subText: 'Write a piece of code '
}, {
  value: 'blockquote',
  name: 'Quote',
  icon: BlockQuoteIcon,
  type: ELEMENT_BLOCKQUOTE,
  subText: 'Showcase a quote'
}, {
  value: 'bulleted-list',
  name: 'Bulleted list',
  icon: BulletedList,
  type: ELEMENT_UL,
  subText: 'Make pointers quickly'
}, {
  value: 'ordered-list',
  name: 'Numbered list',
  icon: NumberedList,
  type: ELEMENT_OL,
  subText: 'Make a list with numbers'
}, {
  value: 'image-upload',
  name: 'Image',
  icon: ImageIcon,
  type: ELEMENT_IMAGE,
  subText: 'Upload an image'
}, {
  value: 'embed',
  name: 'Embed',
  icon: EmbedIcon,
  type: ELEMENT_EMBED,
  subText: 'Embed content from any link'
}, {
  value: 'ai_content',
  name: 'AI Bot',
  icon: AiMagicToolIcon,
  type: ELEMENT_AI_CONTENT,
  subText: 'Generate content on the fly'
}];
const WeaponsList = _weapons;

const getRandomArrayElement = array => array[Math.floor(Math.random() * array.length)];
/**
 * Get text and range from trigger to cursor.
 * Starts with trigger and ends with non-whitespace character.
 * TODO: move to plugins
 */


const getTextFromTrigger = (editor, {
  at,
  trigger
}) => {
  const escapedTrigger = escapeRegExp(trigger);
  const triggerRegex = new RegExp(`^${escapedTrigger}`);
  const noWhiteSpaceRegex = new RegExp(`\\S+`);
  let start = at;
  let end;
  const truthValue = true;

  while (truthValue) {
    end = start;
    if (!start) break;
    start = Editor.before(editor, start);
    const charRange = start && Editor.range(editor, start, end);
    const charText = getEditorString(editor, charRange); // Match non-whitespace character on before text

    if (!charText.match(noWhiteSpaceRegex)) {
      start = end;
      break;
    }
  } // Range from start to cursor


  const range = start && Editor.range(editor, start, at);
  const text = getEditorString(editor, range);
  if (!range || !text.match(triggerRegex)) return;
  return {
    range,
    textAfterTrigger: text.substring(1)
  };
};
/**
 * Set element position below a range.
 */


const setElementPositionByRange = (editor, {
  ref,
  at
}) => {
  if (!at) return;
  const el = ref.current;
  if (!el) return;
  const domRange = ReactEditor.toDOMRange(editor, at);
  const rect = domRange.getBoundingClientRect();
  el.style.top = `${rect.top + window.pageYOffset + 24}px`;
  el.style.left = `${rect.left + window.pageXOffset}px`;
};

const useAddNewBlockAtEnd = editor => {
  return () => {
    ReactEditor.focus(editor);
    const elem = editor.children[editor.children.length - 1];

    if (elem) {
      const isEmpty = Editor.isEmpty(editor, elem);

      if (!isEmpty) {
        const insertPath = Editor.end(editor, []);
        insertNodes(editor, {
          type: ELEMENT_DEFAULT,
          children: [{
            text: ''
          }]
        }, {
          at: [insertPath.path[0] + 1]
        });
        Transforms.select(editor, [editor.children.length - 1]);
      } else {
        Transforms.select(editor, Editor.end(editor, []));
      }
    }
  };
};

const {
  useCallback,
  useMemo,
  Fragment,
  useEffect
} = React;
const EDITOR_ID = 'block-editor'; // Handle multiple combobox

const useComboboxOnChange = () => {
  const weaponOnChange = useOnSlashChange(WeaponsList);
  const isOpen = useComboboxIsOpen();
  const closeMenu = useComboBoxStore(state => state.closeMenu);
  return useCallback(editor => () => {
    let changed = false;
    changed = weaponOnChange(editor);
    if (changed) return;

    if (!changed && isOpen) {
      closeMenu();
    }
  }, [closeMenu, isOpen, weaponOnChange]);
}; // Handle multiple combobox


const ComboboxContainer = () => {
  useComboboxControls();
  return /*#__PURE__*/React.createElement(SlashComboBox, null);
};

const BlockEditor = ({
  editor,
  value,
  onChange,
  isReadOnly,
  id = EDITOR_ID,
  plugins
}) => {
  const comboboxOnChange = useComboboxOnChange();
  const editorT = usePlateEditorRef(id);
  const weaponOnSelect = useSlashOnSelectItem();
  const {
    uploadImage,
    members,
    onMentionUser,
    removeTask,
    setEditorId
  } = useSlatePluginsStore();
  const onAddNewBlock = useAddNewBlockAtEnd(editorT);
  const editorWrapper = document.getElementById('document-wrapper');
  useComments(s => s.activeComment);
  const mentionProps = useMemo(() => Object.assign(Object.assign({}, optionsMentionPlugin), {
    mentionables: members.map(obj => Object.assign({
      name: obj.firstname,
      value: obj.memberId
    }, obj)),
    onAddMentionCallback: ({
      value
    }) => onMentionUser === null || onMentionUser === void 0 ? void 0 : onMentionUser({
      memberId: value
    })
  }), [members, onMentionUser]);
  const focusedEditorId = usePlateId();
  const {
    getMentionSelectProps,
    plugin: mentionPlugin
  } = useMentionPlugin(mentionProps); // Handle multiple combobox

  const comboboxOnKeyDown = useComboboxOnKeyDown({
    onSelectItem: weaponOnSelect
  });
  const pluginsMemo = useMemo(() => {
    const pluginsT = createPlugins([...(plugins || []), createDeserializeHtmlPlugin(), createParagraphPlugin(), createBlockquotePlugin(), createTodoListPlugin(), createHeadingPlugin(), createListPlugin(), createTablePlugin(), createEmbedPlugin(), createCodeBlockPlugin$1(), createAlignPlugin(), createBoldPlugin(), createCodePlugin(), createItalicPlugin(), createHighlightPlugin(), createUnderlinePlugin(), createStrikethroughPlugin(), createSubscriptPlugin(), createSuperscriptPlugin(), createKbdPlugin(), createFontColorPlugin(), createFontBackgroundColorPlugin(), createNodeIdPlugin({
      options: {
        idCreator: () => v4()
      }
    }), createAutoformatPlugin(CONFIG.autoformat), createResetNodePlugin(CONFIG.resetBlockType), createSoftBreakPlugin(CONFIG.softBreak), // Trailing Block causing issue with websocket for live collaboration
    // createTrailingBlockPlugin({ type: ELEMENT_PARAGRAPH }),
    createCalloutTipPlugin(), createTablePlusPlugin(), createBoardPlugin(), createLinkPlugin(), createAiContentPlugin(), createLegalPhPlugin(), createMultiColPlugin(), createColPlugin(), createSelectOnBackspacePlugin({
      options: {
        query: {
          allow: [ELEMENT_IMAGE]
        }
      }
    }), createCommentPlugin(), mentionPlugin, createImagePlugin({
      options: {
        uploadImage
      }
    }), createMicroTaskPlugin({
      options: {
        onRemoveMicroTask: removeTask
      }
    }), createPluginFactory({
      key: 'combobox',
      handlers: {
        onChange: comboboxOnChange,
        onKeyDown: comboboxOnKeyDown
      }
    })(), createIndentPlugin({
      options: {
        indentMax: 3
      }
    }), createPluginFactory({
      key: 'text-color',
      isElement: true,
      isInline: true
    })(), createExitBreakPlugin(CONFIG.exitBreak), createDeserializeMdPlugin(), createHorizontalRulePlugin()], {
      components
    });
    return pluginsT;
  }, [mentionPlugin, plugins, comboboxOnChange, comboboxOnKeyDown, uploadImage]);
  const handleOnChange = useCallback(newValue => {
    onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
  }, []);
  useEffect(() => {
    setEditorId(id);
  }, [id]);
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Plate, {
    id: id,
    plugins: pluginsMemo,
    editor: editor,
    onChange: handleOnChange,
    disableCorePlugins: {
      deserializeHtml: false
    },
    editableProps: {
      readOnly: isReadOnly,
      // TODO: handle drag & drop correctly
      // Refer: https://github.com/ianstormtaylor/slate/blob/main/docs/libraries/slate-react.md#event-handling
      onDrop: () => true,
      onDragStart: () => true,
      onDragEnd: () => true,
      scrollSelectionIntoView: () => null
    },
    value: value
  }, /*#__PURE__*/React.createElement(ComboboxContainer, null), /*#__PURE__*/React.createElement(MentionSelect, Object.assign({
    containerElement: editorWrapper
  }, getMentionSelectProps(), {
    renderLabel: renderMentionItem,
    id: id
  })), focusedEditorId === id ? /*#__PURE__*/React.createElement(SelectionToolbar, null) : null, /*#__PURE__*/React.createElement(Comments, {
    editorId: id
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      paddingBottom: isReadOnly ? '' : '40vh'
    },
    onClick: onAddNewBlock
  }));
};

const optionsMentionPlugin = {
  maxSuggestions: 10,
  insertSpaceAfterMention: false,
  trigger: '@',
  mentionableFilter: s => mentionable => mentionable.email.toLowerCase().includes(s.toLowerCase()) || mentionable.name.toLowerCase().includes(s.toLowerCase()),
  mentionableSearchPattern: '\\S*'
};
const useBlockEditorState = create(devtools(set => ({
  onFetchContent: async () => ({
    content: [],
    status: 'success'
  }),
  setOnFetchContent: func => set({
    onFetchContent: func
  })
})));
export { BlockEditor, getRandomArrayElement, getTextFromTrigger, setElementPositionByRange, useAddNewBlockAtEnd, useBlockEditorState };
//# sourceMappingURL=index.esm.js.map
